import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuController } from '@ionic/angular';
import { LoginService } from 'src/app/services/login/login.service';
import { ProductService } from 'src/app/services/product-service/product.service';
import { Product } from '../../models/type/product.model';

@Component({
  selector: 'app-store-view',
  templateUrl: './store-view.page.html',
  styleUrls: ['./store-view.page.scss'],
})
export class StoreViewPage implements OnInit {
  products;

  constructor(
    private router: Router,
    private menu: MenuController,
    private productService: ProductService,
    private loginService: LoginService
  ) {}

  ngOnInit() {
    // this.products = this.proServ.getPoducts();
    this.productService.getPoducts().subscribe((res) => {
      this.products = res.map(
        (product) => product.payload.doc.data() as Product
      );
    });
  }

  openStore(menu) {
    this.menu.enable(true, 'dash' + menu);
    this.menu.open('dash' + menu);
  }

  storeHome() {
    this.router.navigate(['store-home']);
  }
  orders() {
    this.router.navigate(['store-orders']);
  }
  history() {
    this.router.navigate(['store-history']);
  }
  product() {
    this.router.navigate(['store-view']);
  }

  addProduct() {
    this.router.navigate(['store-add']);
  }

  edit() {
    this.router.navigate(['store-change']);
  }

  logout() {
    this.loginService.logout();
  }
}
